import { ToastDesignTokens } from '@primeuix/themes/types/toast';
import componentColorScheme from '../one-ds-tokens/OneDS-Component-Color-Scheme.json';
import { tFlat } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/toast/index.ts
const tst = componentColorScheme.toast;

export const ToastTelekomDT: ToastDesignTokens = {
  colorScheme: {
    light: {
      info: tFlat(tst.info),
      success: tFlat(tst.success),
      warn: tFlat(tst.warn),
      error: tFlat(tst.error),
    },
  },
};
